// @ts-nocheck

export type TenantGetWithFiles = typeof TenantGetWithFiles[keyof typeof TenantGetWithFiles];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantGetWithFiles = {
  true: 'true',
  false: 'false',
} as const;
